import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import debounce from 'lodash/debounce';
import { useEffect, useRef, forwardRef, useMemo, useState, } from 'react';
import useCombinedRefs from '../hooks/useCombinedRefs';
const styles = {
    inputWrapper: {
        borderRadius: '5px',
        borderWidth: '0.55px',
        borderColor: '#c7c7c7',
        borderStyle: 'solid',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'hidden',
    },
    input: {
        outline: 'none',
        flex: 1,
        height: '100%',
        width: '100%',
    },
    clearButton: {
        height: 'calc(100% - 4px)',
        borderRadius: '50%',
        backgroundColor: 'gray',
        color: 'white',
        aspectRatio: '1',
        fontSize: '60%',
        padding: 0,
    },
};
function mapValue(value) {
    return typeof value === 'number' && value === 0 ? value : value || '';
}
const Input = forwardRef((props, ref) => {
    const { value: externalValue = undefined, name, style = {
        input: {},
        inputWrapper: {},
    }, onChange, checkValue = () => true, type = 'text', autoSelect = false, className, renderIcon, canClear = false, onClear, datalist = [], debounceTime = 0, ...otherProps } = props;
    const [internalValue, setInternalValue] = useState();
    const value = debounceTime ? internalValue : externalValue;
    const localRef = useRef();
    const combinedRef = useCombinedRefs([ref, localRef]);
    const [isDebounced, setDebouncedStatus] = useState(false);
    const debounceOnChange = useMemo(() => debounce((e) => {
        onChange?.(e);
        setDebouncedStatus(true);
    }, debounceTime), [debounceTime, onChange]);
    useEffect(() => {
        if (autoSelect) {
            combinedRef?.current?.select();
        }
    }, [autoSelect, combinedRef]);
    useEffect(() => {
        if (debounceTime) {
            setInternalValue(externalValue);
        }
    }, [debounceTime, externalValue]);
    function onChangeHandler(e) {
        e.stopPropagation();
        e.preventDefault();
        const val = e.target.value;
        setDebouncedStatus(false);
        if (checkValue(val)) {
            if (debounceTime) {
                setInternalValue(val);
                debounceOnChange(e);
            }
            else {
                onChange?.(e);
            }
        }
    }
    function clearHandler() {
        localRef.current?.setAttribute('value', '');
        onClear?.();
    }
    return (_jsxs("div", { style: {
            ...((renderIcon || canClear) && { padding: '0 5px' }),
            ...styles.inputWrapper,
            ...style?.inputWrapper,
        }, className: `input ${className || ''} `, children: [renderIcon?.(), _jsx("input", { ...otherProps, className: isDebounced ? 'debounce-end' : '', ref: combinedRef, name: name, style: {
                    ...styles.input,
                    ...style?.input,
                }, type: type, value: mapValue(value), onChange: onChangeHandler, list: `${name || ''}-data-list` }), canClear && value && (_jsx("button", { type: "button", style: styles.clearButton, onClick: clearHandler, children: _jsx("span", { style: { display: 'block', margin: '0 auto' }, children: "\u2715" }) })), _jsx("datalist", { id: `${name || ''}-data-list`, children: datalist.map((value) => (_jsx("option", { value: value }, value))) })] }));
});
export default Input;
